import { useState } from "react";
import usePageLoader from '../hooks/usePageLoader';
import { ShimmerBox, ShimmerStatCard } from '../components/common/Shimmer';
import { FiZap, FiCalendar } from "react-icons/fi";
import PricingTab from "./billing/PricingTab";
import InvoicesTab from "./billing/InvoicesTab";

const TABS = [
  { key: "plan",     label: "Plan & Pricing" },
  { key: "invoices", label: "Invoices & Usage" },
];

function BillingSkeleton() {
  return (
    <div className="flex-1 overflow-y-auto bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 py-8 space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="bg-white border rounded-xl p-5 space-y-4">
              <ShimmerBox h="h-4" w="w-24" />
              <ShimmerBox h="h-8" w="w-20" />
              <ShimmerBox h="h-3" w="w-full" />
              <ShimmerBox h="h-3" w="w-3/4" />
              <ShimmerBox h="h-10" w="w-full" rounded="rounded-lg" />
            </div>
          ))}
        </div>
        <div className="bg-white border rounded-xl overflow-hidden">
          <div className="px-6 py-4 border-b"><ShimmerBox h="h-4" w="w-32" /></div>
          <div className="p-6 space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex items-center justify-between">
                <ShimmerBox h="h-3" w="w-32" />
                <ShimmerBox h="h-3" w="w-20" />
                <ShimmerBox h="h-5" w="w-16" rounded="rounded-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Billing() {
  const [activeTab, setActiveTab] = useState("plan");
  const loading = usePageLoader();

  return (
    <div className="-m-6 flex flex-col h-[calc(100vh-4rem)]">

      {/* ── Sticky header ── */}
      <div className="shrink-0 bg-white border-b">

        {/* Top row */}
        <div className="px-6 py-4 flex items-center justify-between border-b">
          <div>
            <h1 className="text-xl font-bold text-gray-900">Billing</h1>
            <p className="text-sm text-gray-500 mt-0.5">Manage your plan, usage, and payment history.</p>
          </div>

          {/* Current plan badge */}
          <div className="flex items-center gap-3 bg-primary-light border border-primary/20 rounded-xl px-4 py-2.5">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-indigo-500 flex items-center justify-center shadow-sm shadow-primary/30">
              <FiZap size={14} className="text-white" />
            </div>
            <div>
              <p className="text-sm font-bold text-primary leading-tight">Pro Plan</p>
              <p className="text-[11px] text-primary/60 flex items-center gap-1 mt-0.5">
                <FiCalendar size={9} /> Renews Jun 10, 2026
              </p>
            </div>
          </div>
        </div>

        {/* Tab row */}
        <div className="px-6 py-3 flex items-center">
          <div className="flex items-center border rounded-lg overflow-hidden text-sm font-medium w-fit">
            {TABS.map((t) => (
              <button
                key={t.key}
                onClick={() => setActiveTab(t.key)}
                className={`px-4 py-2 transition whitespace-nowrap ${
                  activeTab === t.key ? "bg-primary text-white" : "text-gray-500 hover:bg-gray-50"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {loading ? <BillingSkeleton /> : (
      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 py-8">
          {activeTab === "plan"     && <PricingTab />}
          {activeTab === "invoices" && <InvoicesTab />}
        </div>
      </div>
      )}

    </div>
  );
}
